<template>
  <div>
    <el-card
      shadow="hover"
      style="width: 748px;"
    >
      <h3>
        Xero Export Logs
        <el-button
          v-if="logs.length > 0"
          type="danger"
          size="mini"
          plain
          @click="clear_logs"
        >
          Clear logs
        </el-button>
      </h3>

      <el-scrollbar style="height: auto">
        <div
          v-for="(log, i) in logs"
          :key="i"
          style="margin-bottom: 10px"
        >
          <el-alert
            :title="log.message"
            :type="log.type"
            :closable="true"
            :description="log.timestamp"
            show-icon
          />
        </div>
      </el-scrollbar>
    </el-card>
  </div>
</template>

<script>
import Cable from '../../channels/cable';

export default {
  name: 'XeroExportLog',
  data() {
    return {
      logs: [],
      subscription: null
    };
  },
  beforeDestroy() {
    if (this.subscription) Cable.subscriptions.remove(this.subscription);
  },
  methods: {
    connectToCable() {
      if (this.subscription) return; // already connected

      this.subscription = Cable.subscriptions.create('XeroExportsChannel', {
        connected: () => {
          console.log('Connected to XeroExportsChannel');
        },
        disconnected: () => {
          console.warn('Disconnected from XeroExportsChannel');
        },
        received: (data) => {
          this.logs.unshift(data);
        }
      });
    },
    clear_logs() {
      this.logs = [];
    },
  }
};
</script>
